import React from 'react';

const Hr = () => {
	return (
		<hr className="sh-hr"/>
	);
}

export default Hr;
